<template>
  <div :class="{inventory, active: count }">
    <div class="inventory__image">
      <img
        v-if="inventory.image"
        :src="inventory.image"
        :alt="inventory.name"
      />
    </div>
    <span class="inventory__name" v-html="inventory.name"></span>
    <span class="inventory__size">{{ inventory.size }}m³</span>
    <div class="inventory__action">
      <button
        type="button"
        class="inventory__num minus"
        @click="count > 0 && count--"
      >
        <i class="vn-icons vn-icons-minus"></i>
      </button>
      <input
        type="text"
        readonly
        class="inventory__count"
        :value="count > 0 ? count : ''"
      />
      <button type="button" class="inventory__num plus" @click="count++">
        <i class="vn-icons vn-icons-plus"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { camelCase } from 'lodash'
import { mapWritableState } from 'pinia'
import { useStagesStore } from '../stores/stages'

export default {
  name: 'InventoryItem',
  props: {
    room: {
      type: Object,
      default: null,
    },
    inventory: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapWritableState(useStagesStore, ['values', 'apiData']),
    camelCase,
    roomSlug() {
      return this.room.slug
    },
    inventorySlug() {
      return this.inventory.slug
    },
    roomObj() {
      return this.values.rooms.find((r) => r.slug === this.roomSlug)
    },
    inventoryObj() {
      return this.roomObj.inventories.find((i) => i.slug === this.inventorySlug)
    },
    allInventoryCount() {
      const inventories = this.roomObj.inventories

      let sum = 0

      for (const item of inventories) {
        if (item.count > 0) {
          sum++
        }
      }

      return sum
    },
    count: {
      get() {
        return this.inventoryObj.count
      },
      set(newVal) {
        this.inventoryObj.count = newVal
        this.roomObj.count = this.allInventoryCount
      },
    },
  },
}
</script>

<style scoped lang="scss">
.inventory {
  text-align: center;
  background-color: #fff;
  padding: 30px 10px 10px;
  position: relative;
  border: solid 3px #fff;


  @include media-breakpoint-up(lg) {
    padding-bottom: 60px;
  }

  @include media-breakpoint-down(lg) {
    padding: 10px 120px 10px 80px;
    text-align: left;
    min-height: 70px;
  }

  @include media-breakpoint-down(sm) {
    padding: 10px 10px 40px 80px;
    min-height: 110px;
  }

  &__image {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 10px;
    width: 50px;
    height: 50px;
    border-radius: 5px;

    @include media-breakpoint-down(lg) {
      position: absolute;
      left: 10px;
      top: 10px;
      bottom: 10px;
    }

    img {
      height: 100%;
      width: auto;
    }
  }

  &__name {
    display: block;
    margin: 0 0 5px;
    text-align: center;
    font-weight: 700;
    font-size: 13px;

    @include media-breakpoint-down(lg) {
      text-align: left;
    }
  }

  &__size {
    display: block;
    text-align: center;

    @include media-breakpoint-down(lg) {
      text-align: left;
    }
  }

  &__action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;

    @include media-breakpoint-up(lg) {
      position: absolute;
      bottom: 10px;
      left: 10px;
      right: 10px;
    }

    @include media-breakpoint-down(lg) {
      margin-top: 0;
      position: absolute;
      right: 10px;
      top: 10px;
      bottom: 10px;
      width: 110px;
      order: 1;
    }

    @include media-breakpoint-down(sm) {
      left: 10px;
      top: auto;
      width: auto;
    }
  }

  &__num {
    @include reset-btn;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    font-size: 16px;
    border: 1px solid var(--vn-secondary-color);
    color: var(--vn-secondary-color);

    &.plus {
      @include media-breakpoint-between(lg, sm) {
        order: 2;
      }
    }

    &.minus {
      @include media-breakpoint-between(lg, sm) {
        order: 3;
      }
    }
  }

  &__count {
    font-weight: 700;
    font-size: 13px;
    color: var(--vn-secondary-color);
    line-height: 1;
    text-align: center;
    border: 0;
    padding: 0;
    outline: none;
    width: 30px;
  }

  .vn-icons-minus {
    position: relative;
    top: -7px;
  }
}
.inventory.active {
  border: solid 3px var(--vn-secondary-color);
}
</style>
